/* FileServer.js */

"use strict";
const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "file_server",
    label: "File Server",
    disabled: false,
    app: "GameConsole",
    order: 8, // Depricated -- Newer solution uses order from index.js
    section: "GameCenter",
    license: ["GLUWARE", "OSM"],
    accessPerm: ["fileServerAccess"],
    pageTitle: "Gluware File Server",
    helpLink: "OS%20Manager/File-Server-quick-ref.htm",
    navIcon: "fileserver.solution",
    iconName: "branding.fileServer",
    lmrbNamespaces: [Registrations.FILE_EXPLORER_LMRB],
    editorNamespaces: [Registrations.FILE_INSTANCE_EDITOR],
    fileExplorer: {
        viewNamespaces: [Registrations.FILE_EXPLORER_GRID],
        actionNamespaces: [
            Registrations.FILE_EXPLORER_ACTION_CREATE_FOLDER,
            Registrations.FILE_EXPLORER_ACTION_RENAME_FOLDER,
            Registrations.FILE_EXPLORER_ACTION_CREATE_FILE,
            Registrations.FILE_EXPLORER_ACTION_EDIT_FILE,
            Registrations.FILE_EXPLORER_ACTION_DELETE_FILE,
        ],
    },
    fileEditor: {
        viewNamespaces: [Registrations.FIE_VIEW_DETAILS, Registrations.FIE_VIEW_ACTIVITY],
        actionNamespaces: [Registrations.FIE_ACTION_DELETE],
    },
};
